import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { RxStompService } from '@stomp/ng2-stompjs';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserConversation } from '../gestion-jardin/gestion-messagarie/models/UserConversation.model';
import { UserstoSendResponceDTO } from '../gestion-jardin/gestion-messagarie/models/UsersToSendResponceDTO';
import { ChatMessageDTO } from '../gestion-jardin/gestion-messagarie/models/ChatMessageDTO';
import { environment } from '../../../../environments/environement';
import { FullConversation } from '../gestion-jardin/gestion-messagarie/FullConversation .model';
import { myRxStompConfig } from '../gestion-jardin/gestion-messagarie/myRxStompConfig';

@Injectable({
  providedIn: 'root'
})
export class MessagerieService {
  baseUrl = environment.apiUrl;
  private SERVER_URL = `${this.baseUrl}/ws`;

  private messageSubject = new BehaviorSubject<any>(null);
  messages$ = this.messageSubject.asObservable();

  private unreadCountRefresh$ = new Subject<void>();
  unreadCountRefreshed$ = this.unreadCountRefresh$.asObservable();

  refreshUnreadCount(): void {
    this.unreadCountRefresh$.next();
  }

  constructor(private rxStompService: RxStompService,
              private http: HttpClient,
              @Inject(PLATFORM_ID) private platformId: Object) {}

  public connect(): void {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('presence');

    if (this.rxStompService.connected()) {
      return;
    }

    const config = { ...myRxStompConfig };
    if (token) {
      config.connectHeaders = { Authorization: `Bearer ${token}` };
    }
    this.rxStompService.configure(config);
    this.rxStompService.activate();

    const groupDestination = '/topic/all';
    this.rxStompService.watch(groupDestination).subscribe({
      next: (message) => {
        const newMessage = JSON.parse(message.body);
        this.messageSubject.next(newMessage);
      },
      error: () => {},
    });

    if (userId) {
      const userDestination = `/user/${userId}/specific`;
      this.rxStompService.watch(userDestination).subscribe({
        next: (message) => {
          const newMessage = JSON.parse(message.body);
          this.messageSubject.next(newMessage);
        },
        error: () => {},
      });
    }
  }

  public disconnect(): void {
    this.rxStompService.deactivate();
  }

  clearMessages() {
    this.messageSubject.next(null); // Clear current message
  }
  private getAuthHeaders(): { [header: string]: string } {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
    return {};
  }

  // Récupérer les conversations de l'utilisateur
getUserConversations(userId: number, etablissementId: number): Observable<UserConversation[]> {
  const params = new HttpParams()
    .set('userId', userId.toString())
    .set('etablissementId', etablissementId.toString());

  return this.http.get<UserConversation[]>(`${this.baseUrl}/messages/conversations`, {
    headers: this.getAuthHeaders(),
    params: params,
  });
}

  // Récupérer les utilisateurs à envoyés
  getUsersToSend(excludedUserId: number): Observable<UserstoSendResponceDTO[]> {
    const params = new HttpParams().set('excludedUserId', excludedUserId.toString());
    return this.http.get<UserstoSendResponceDTO[]>(`${this.baseUrl}/users/users-to-send`, {
      headers: this.getAuthHeaders(),
      params: params,
    });
  }

  // Récupérer les messages d'une conversation
  getMessages(userConnectedId: number, conversationId: number): Observable<FullConversation[]> {
    return this.http.get<FullConversation[]>(`${this.baseUrl}/messages/${conversationId}`, {
      headers: this.getAuthHeaders(),
      params: { userConnectedId: userConnectedId.toString() },
    });
  }

  markConversationAsRead(conversationId: number, userId: number): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/messages/conversation/${conversationId}/mark-read/${userId}`, {}, {
      headers: this.getAuthHeaders()
    });
  }

  sendMessage(message: ChatMessageDTO): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/messages/send`, message, { headers: this.getAuthHeaders() });
  }

  // Upload file
  uploadFile(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/messages/upload-file`, formData, {
      headers: this.getAuthHeaders()
    });
  }

  // Récupérer le nombre de messages non lus
  getUnreadMessageCount(userId: number): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/messages/unread-count/${userId}`, {
      headers: this.getAuthHeaders()
    });
  }

  // Upload voice message
  uploadVoiceMessage(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/messages/upload-voice`, formData, {
      headers: this.getAuthHeaders()
    });
  }

  // Delete a message
  deleteMessage(messageId: number, userId: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/messages/${messageId}`, {
      headers: this.getAuthHeaders(),
      params: { userId: userId.toString() }
    });
  }
}
